import React from 'react';
import logo from '../sprites/logo.png';
import SEOHelmet from '../components/SEOHelmet';

function Home() {
  return (
    <div>
      <SEOHelmet 
        title="Code It Up 6.0 - Ultimate Hackathon for Developers & AI Enthusiasts"
        description="Join Code It Up 6.0, the premier hackathon event! Compete in AI and development challenges, network with innovators, learn from mentors, and build amazing projects. Perfect for beginners to experts."
        keywords="hackathon 2025, coding competition, AI hackathon, developer event, programming challenge, innovation challenge, tech competition, developer networking, coding challenge, AI development, machine learning hackathon"
        canonical="https://code-it-up-6.netlify.app/"
        ogTitle="Code It Up 6.0 - Join the Ultimate Hackathon"
        ogDescription="Be part of Code It Up 6.0! A premium hackathon for developers, AI enthusiasts, and innovators. Compete, learn, network, and showcase your skills."
      />
      <img src={logo} alt="Code It Up 6.0" className="home-logo" />
      <h1>Welcome to Code It Up 6.0</h1>
      
      <div className="board">
        <h2>Are You Ready, Coders?</h2>
        <p>
        </p>
        <p style={{ marginTop: '15px', fontStyle: 'italic' }}>
          Aye, aye, Captain <br></br>
          I can't hear you<br></br>
          Aye, aye, Captain<br></br>
          Ohhhhhhhhhh <br></br>
          Who lives in a code under the sea?<br></br>
          Code It Up 6.0!<br></br>
        </p>
      </div>
    </div>
  );
}

export default Home;
